<template>
  <div class="q-ml-md q-mt-md">
    <PageHeader
      title="Monitoramento Geral"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <flexmonster
      v-if="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :exportName="'Monitoramento_Geral'"
      :grid="layout"
      :updateLink="updateLink"
      :salvarType="'monitoramentogeral'"
      :showTotals="showTotals"
      :showGrandTotals="'columns'"
      :filtros="filtros"
    />
    <div
      v-else
      class="row col-12 justify-center items-center"
      style="height: 70vh"
    >
      <LoadingLogo />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import LoadingLogo from "../../../components/loading/LoadingLogo.vue";
import Flexmonster from "../../relatorios/components/Flexmonster.vue";
import PageHeader from "../../../components/PageHeader.vue";
export default {
  components: { Flexmonster, LoadingLogo, PageHeader },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: [
        {
          uniqueName: "semana",
          filter: {
            measure: {
              uniqueName: "quantidade",
              aggregation: "sum",
            },
            //   query: {
            //     top: 5,
            //   },
          },
        },
        {
          uniqueName: "dados_unnested_entregaunidadenome",
        },
        {
          uniqueName: "semana",
        },
        {
          uniqueName: "ano",
        },
        {
          uniqueName: "origemrequisicao",
        },
        {
          uniqueName: "quantidade",
        },
      ],
      measures: [
        {
          uniqueName: "quantidade",
          aggregation: "sum",
        },
      ],
      rows: [
        {
          uniqueName: "cliente",
        },
      ],
      reportFilters: "",
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("classic");
    const loadingValue = ref("");
    const types = ref([]);
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");

    const getDadosMonitoramento = async () => {
      try {
        let filtrosObject = {
          // unidade: singleValue.id,
          // cliente: singleValue.cliente.clienteId,
        };
        loadingValue.value = true;
        const response = await store.dispatch(
          "office/receberDadosMonitoramentoGeral",
          {
            // unidadeId: singleValue.id,
            // clienteId: singleValue.cliente.clienteId,
          }
        );
        const mapeamento = {
          ano: {
            type: "string",
          },
          semana: {
            type: "string",
          },
          Semana: {
            type: "string",
          },
        };
        link.value = response.data.resultado.dados;
        updateLink.value++;
        loadingValue.value = false;
        types.value = mapeamento;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
      } catch (error) {
        console.log(error);
      }
    };

    const getRelatorioSalvo = async () => {
      if (id) {
        loadingValue.value = true;

        try {
          const response = await store.dispatch(
            "rel/getRelatorioSalvoEspecifico",
            {
              id,
            }
          );

          let dados = await JSON.parse(response.data.results[0].relatorio);
          filtros.value = response.data.results[0].filtros;
          layout.value = await dados.leyout;
          showTotals.value = await dados.showTotals;
          link.value = await response.data.results[0].link;

          slice.value.columns = await dados.columns;
          slice.value.rows = await dados.rows;
          slice.value.reportFilters = await dados.filtros;
          slice.value.measures = await dados.values;
          exibir.value = true;

          slice.value.rows.forEach((e) => {
            e.type = "number";
          });

          let resultad = dados.values.reduce(function (target, key) {
            target[key.caption.split(" ")[2]] = { type: "number" };
            return target;
          }, {});

          resultad.aggregations = {
            number: ["sum", "average"],
            date: ["max", "min"],
            string: ["sum", "average"],
          };

          types.value = resultad;
          loadingValue.value = false;
        } catch (error) {
          console.log(error);
        }
      } else {
        getDadosMonitoramento();
        return;
      }
    };

    onMounted(getRelatorioSalvo);

    return {
      getDadosMonitoramento,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      id,
      getRelatorioSalvo,
      filtros,
      showTotals,
    };
  },
};
</script>
